export const scrollToFirstFormField = (fieldNames: string[]) => {
  for (const field of fieldNames) {
    const element = document.querySelector(`[data-form-field="${field}"]`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return field;
    }
  }

  return null;
};

export const getNestedFormFieldNames = (
  parentField: string,
  errors: Record<string, unknown> | undefined,
): string[] => {
  if (!errors || typeof errors !== 'object') return [];

  return Object.keys(errors).map((key) => `${parentField}.${key}`);
};
